import PropTypes from 'prop-types';

import styles from './CalendarTimeSlotsIntro.scss';

export const CalendarTimeSlotsIntro = ({ children = null }) => (
  <div className={styles.CalendarTimeSlotsIntro} data-testid="CalendarTimeSlotsIntro">
    {children}
  </div>
);

CalendarTimeSlotsIntro.propTypes = {
  children: PropTypes.node,
};
